import Vue from 'vue'
import Router from 'vue-router'
import Companies from '@/components/Companies'
import Dashboard from '@/components/Dashboard'
import Duty from '@/components/Duty'
import Duties from '@/components/Duties'
import Tour from '@/components/Tour'
import TourTemplate from '@/components/TourTemplate'
import TourEdit from '@/components/TourEdit'
import TourTemplateEdit from '@/components/TourTemplateEdit'
import Districts from '@/components/Districts'
import Streets from '@/components/Streets'
import Login from '@/components/Login'
import store from '@/store'
import Stats from '@/components/Stats'
import Vehicle from '@/components/Vehicle'

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next({name: 'login'}).catch(() => {})
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/duties/:id?',
      name: 'duties',
      component: Duties,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/duties/:id',
      name: 'duty',
      component: Duty,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/duty_new',
      name: 'duty_new',
      component: Duty,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tour',
      name: 'tour',
      component: Tour,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tour/:id',
      name: 'tour-edit',
      component: TourEdit,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tour/:id/pdf',
      name: 'tour-pdf',
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tourtemplate',
      name: 'tour_template',
      component: TourTemplate,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tourtemplate/:id',
      name: 'tourtemplate-edit',
      component: TourTemplateEdit,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/settings',
      name: 'settings',
      beforeEnter: ifAuthenticated
    },
    {
      path: '/master_data',
      name: 'master_data',
      beforeEnter: ifAuthenticated
    },
    {
      path: '/districts',
      name: 'districts',
      component: Districts,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/streets',
      name: 'streets',
      component: Streets,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/companies',
      name: 'companies',
      component: Companies,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/vehicles',
      name: 'vehicles',
      component: Vehicle,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/stats',
      name: 'stats',
      component: Stats,
      beforeEnter: ifAuthenticated
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js